import { Component, OnInit } from '@angular/core';

import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

import { EditBlockedSlotMode } from '../../models/edit-blocked-slot-confirmation-form.model';

@Component({
    selector: 'app-blocked-slot-edit-confirmation-modal',
    templateUrl: './blocked-slot-edit-confirmation-modal.component.html',
    styleUrls: ['./blocked-slot-edit-confirmation-modal.component.scss'],
    standalone: false
})
export class BlockedSlotEditConfirmationModalComponent implements OnInit {
    public onClose: Subject<EditBlockedSlotMode> = new Subject<EditBlockedSlotMode>();

    form: UntypedFormGroup;

    editMode = EditBlockedSlotMode;

    constructor(public bsModalRef: BsModalRef, private formBuilder: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            editMode: new UntypedFormControl(EditBlockedSlotMode.thisEvent)
        });
    }

    onConfirm(): void {
        this.onClose.next(this.selectedEditMode);
        this.bsModalRef.hide();
    }

    onDismiss(): void {
        this.onClose.next(null);
        this.bsModalRef.hide();
    }

    get selectedEditMode(): EditBlockedSlotMode {
        return this.form.controls.editMode.value as EditBlockedSlotMode;
    }
}
